<template>
  <el-button size="mini" type="primary" @click="addShow()" style="margin-right:10px" plain>添加代理记账公司</el-button>
  <el-dialog
    v-model="dialogFormVisible"
    title="添加代理记账公司"
    width="30%"
    :before-close="handleClose"
  >
    <el-form :model="temp">
      <el-form-item label="公司名称：" :label-width="formLabelWidth">
        <el-input class="input" size="mini" v-model="temp.name"></el-input>
      </el-form-item>

      <!-- <el-form-item label="纳税人识别号：" :label-width="formLabelWidth">
        <el-input class="input" size="mini" v-model="temp.tax_no"></el-input>
      </el-form-item> -->

      <!-- <el-form-item label="公司类型：" :label-width="formLabelWidth">
        <el-select size="mini" v-model="temp.type" placeholder="请选择" clearable>
          <el-option v-for="item in types" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item label="用户名：" :label-width="formLabelWidth">
        <el-input class="input" size="mini" v-model="temp.userName"></el-input>
      </el-form-item>

      <el-form-item label="密码：" :label-width="formLabelWidth">
        <el-input class="input" size="mini" v-model="temp.password"></el-input>
      </el-form-item>

      
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="saveCompany()">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>

import { addOrg } from "@/api/ea";
export default {
  props: {
    
  },
  data () {
    return {
      formLabelWidth: "110px",
      dialogFormVisible: false,
      types: [{
        name: "小规模纳税人",
        value: 1,
      },{
        name: "一般纳税人",
        value: 2,
      }],
      temp: {
      },
    }
  },
  created () {
    
  },
  methods: {
    addShow(){
      this.dialogFormVisible = true
    },
    saveCompany(){
      if(!this.temp.name){
        this.$qzfMessage("请输入公司名称", 1)
        return
      }
      if(!this.temp.password){
        this.$qzfMessage("请输入密码", 1)
        return
      }
      addOrg(this.temp).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("添加成功")
          this.dialogFormVisible = false
          this.$emit("success")
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.input{
  width: 200px;
}
</style>